import { createEffect, createStore } from "effector";
import { PlayerProfile } from "../../../types/alice-bob";
import { getLeaders } from "../api/api";

export const $leaderBoard = createStore<Array<PlayerProfile>>([]);

export const fetchLeaderBoard = createEffect(async () => {
    const ranking = await getLeaders();
    return ranking;
});

$leaderBoard.on(fetchLeaderBoard.doneData, (_, newData) => newData);